import { Box, Text } from "grommet";
import { useMemo } from "react";
import { animated, useSpring } from "react-spring";
import { rankItemTheme } from "./rankItemTheme";
import "./style.css";

interface Props {
  title: string;
  color: string;
  amount: number;
  requiredTokens: number;
}
const DenyStatusProgress = (props: Props) => {
  const { color, amount, title, requiredTokens } = props;

  const gradientTwo = useMemo(() => {
    const theme = rankItemTheme;
    const { colorOne, colorTwo, colorThree } = theme;
    return `linear-gradient(-45deg, ${colorOne}, ${colorTwo}, ${colorThree})`;
  }, []);
  const { val } = useSpring({
    val: amount * 100 + "%",
    from: { val: "0%" },
    config: {
      mass: 10,
      friction: 20,
      tension: 50,
    },
  });
  return (
    <Box>
      <Box direction="row" justify="between">
        <Text color={color} size="xlarge" weight={"bolder"}>
          {title}
        </Text>
        <Text color={color} size="xlarge" weight={"bolder"}>
          {10 - requiredTokens}/10
        </Text>
      </Box>
      <Box
        style={{
          background: gradientTwo,
          backgroundSize: "600% 600%",
          WebkitAnimation: "Gradient 10s ease infinite",
          MozAnimation: "Gradient 10s ease infinite",
          animation: "Gradient 10s ease infinite",
          padding: 3,
          margin: 2,
          borderRadius: 12,
          fontFamily: "Orbitron",
          backgroundPosition: 0,
          // backgroundPosition: gradientVal.to((gradientVal) =>
          //   Math.floor(gradientVal)
          // ),
        }}
      >
        <animated.div
          style={{
            width: val.to((v) => v),
            backgroundColor: color,
            height: "20px",
            borderRadius: 12,
          }}
        ></animated.div>
      </Box>
    </Box>
  );
};

export default DenyStatusProgress;
